import CalendarSyncingIntegration from '../../components/integrations/CalendarSyncingIntegration.jsx';
import PaymentsIntegration from '../../components/integrations/PaymentsIntegration';
import SectionPicker from '../../components/SectionPicker.jsx';
import { useState } from 'react';
import OtherIntegrations from '../../components/integrations/OtherIntegrations.jsx';
import BreelyFeatures from '~/components/integrations/BreelyFeatures';
import { useBusinessInfo } from '~/lib/Queries';
import PageHeading from "~/components/PageHeading";

const IntegrationsPage = ({ initialTab }) => {
    const { data: businessData } = useBusinessInfo();
    const [section, setSection] = useState(initialTab || 'features');

    const isLimitedUser = !businessData?.permissions?.isFullAccess;

    return (
        <div>
            <PageHeading heading="Integrations" />
            {!isLimitedUser && (
                <div className="flex mb-6 w-full xs:w-auto">
                    <SectionPicker
                        className="w-full xs:w-auto"
                        value={section}
                        onChange={setSection}
                        options={[
                            { value: 'features', label: 'Breely Features' },
                            { value: 'syncing', label: 'Calendar Syncing' },
                            { value: 'payments', label: 'Payments' },
                            { value: 'other', label: 'Other' },
                        ]}
                    />
                </div>
            )}

            {section === 'features' && !isLimitedUser && <BreelyFeatures />}

            {section === 'payments' && !isLimitedUser && (
                <PaymentsIntegration />
            )}

            {(section === 'syncing' || isLimitedUser) && (
                <CalendarSyncingIntegration />
            )}

            {section === 'other' && !isLimitedUser && <OtherIntegrations />}
        </div>
    );
};

export default IntegrationsPage;
